module.exports = __webpack_public_path__ + "static/media/logo_white.4b44e905.png";